import { render } from "./Hotspot.vue?vue&type=template&id=367770d6&scoped=true"
import script from "./Hotspot.vue?vue&type=script&lang=js"
export * from "./Hotspot.vue?vue&type=script&lang=js"

import "./Hotspot.vue?vue&type=style&index=0&id=367770d6&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367770d6"]])

export default __exports__